import React from "react";
import styled from "styled-components";
import { Edit2 } from "react-feather";
import { SPOTTER_STRINGS } from "./strings";

/**
 * Shared "this has an unsaved edit" pill — amber instead of neutral, with a pencil icon. Reused
 * on: field/glossary-entry row headers (this row has a pending, unsaved change) and the Changes
 * panel's item rows (mirrors Vault's `NewBadge`/`RemoveBadge`, collapsed to one "Edited" state
 * since mapping/glossary edits aren't add/remove).
 */
const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 99px;
  white-space: nowrap;
  font-family: ui-monospace, Menlo, monospace;
  background: var(--spotterAccentSoft);
  color: var(--spotterAccent);
  border: 1px solid var(--spotterAccentLine);
  flex-shrink: 0;
`;

const SpotterEditedTag = () => (
  <Tag>
    <Edit2 size={11} />
    {SPOTTER_STRINGS.editedTag}
  </Tag>
);

export default SpotterEditedTag;
